{
  "datatable": {
    "rowsPerPage": "Filas por página"
  },
  "department": {
    "addDepartment": "Añadir Departamento",
    "createNewDepartment": "Crear Nuevo Departamento",
    "departmentAdmin": "Administrador del Departamento",
    "departmentName": "Nombre del Departamento",
    "institution": "Nombre de la Institución",
    "institutionName": "Nombre de la Institución",
    "searchDepartments": "Buscar Departamento(s)",
    "thisFieldIsRequired": "Este campo es obligatorio"
  },
  "general": {
    "accessDenied": "Acceso Denegado",
    "add": "Añadir",
    "back": "Atrás",
    "cancel": "Cancelar",
    "close": "Cerrar",
    "dateAdded": "Fecha Añadida",
    "dateUpdated": "Fecha Actualizada",
    "delete": "Eliminar",
    "edit": "Modificar",
    "loading": "Cargando ...",
    "no": "No",
    "noData": "Sin Datos",
    "ok": "Ok",
    "remove": "Remover",
    "save": "Guardar",
    "selectAll": "Seleccionar Todo",
    "yes": "Sí"
  },
  "institution": {
    "contact": "Contacto",
    "createNewInstitution": "Crear Nueva Institución",
    "name": "Nombre",
    "region": "Región",
    "searchInstitutions": "Buscar institución(es)",
    "switch": "Cambiar",
    "switchedTo": "Las instituciones se cambiaron a",
    "unableToSwitch": "Imposible cambiar"
  },
  "menu": {
    "departments": "Departamentos",
    "home": "Inicio",
    "institutions": "Instituciones",
    "procedure": "Procedimiento",
    "procedures": "Procedimientos",
    "scheduling": "Programación",
    "users": "Usuarios"
  },
  "procedure": {
    "allSteps": "Todos los Pasos",
    "authors": "Autor",
    "category": "Categoría",
    "createNewStep": "Crear Nuevo Paso",
    "defineFeedback": "Definir Feedback",
    "description": "Descripción",
    "disableProcedure": "Inhabilitar Procedimiento",
    "editProceduresInformation": "Editar la Información del Procedimiento",
    "information": "Información",
    "language": "Idioma",
    "languagesAvailable": "Idiomas Disponibles",
    "media": "Imágenes y Videos",
    "name": "Nombre",
    "owner": "Propietario",
    "procedureCategory": "Categoría del Procedimiento",
    "procedureLanguage": "Idioma del Procedimiento",
    "procedureName": "Nombre del Procedimiento",
    "procedureNotFound": "Procedimiento No Encontrado",
    "public": "Público",
    "publicPrivate": "Público/Privado",
    "revisionHistory": "Historial de Revisiones",
    "searchSteps": "Buscar Paso(s)",
    "seeFeedback": "Ver Feedback",
    "statistics": "Estadísticas",
    "step": "Paso",
    "thisFieldIsRequired": "Este campo es obligatorio",
    "unableToLoad": "No se puede cargar el procedimiento",
    "viewAs": "Ver Como"
  },
  "procedures": {
    "addProcedure": "Añadir procedimiento",
    "category": "Categoría",
    "deleteProcedure": "Eliminar Procedimiento",
    "department": "Departamento",
    "filter": "Filtrar",
    "private": "Privado",
    "procedures": "Procedimientos",
    "public": "Público",
    "publicPrivate": "Público/Privado",
    "searchProcedures": "Buscar procedimientos",
    "sort": "Clasificar"
  },
  "step": {
    "addDescription": "Agregar descripción",
    "addParentStep": "Añadir paso principal",
    "chooseParentSep": "Elegir el paso principal",
    "chooseStepOption": "Elegir opción del paso",
    "chooseTransitionType": "Elegir el tipo de transición",
    "chooseType": "Elige tipo",
    "description": "Descripción",
    "dropFilesOrClickToUpload": "Suelta los archivos aquí o haz clic para subir",
    "editStep": "Editar Paso",
    "insertMaxValue": "Insertar valor máximo (MAX)",
    "insertMinValue": "Insertar valor mínimo (MIN)",
    "insertOption": "Insertar opción",
    "option": "Opción",
    "owner": "Propietario",
    "parentStep": "Paso principal",
    "previousStep": "Paso anterior",
    "saveMedia": "Guardar Imágenes y Vídeos del paso",
    "stepMedia": "Imágenes y Vídeos del Paso",
    "transitionToNextStep": "Transición al siguiente paso",
    "transitionType": "Tipo de transición",
    "type": "Escribir",
    "value": "Valor",
    "viewInProcedure": "Ver en el Procedimiento"
  },
  "user": {
    "accountSettings": "Ajustes de la Cuenta",
    "chooseUserRole": "Elegir Rol del Usuario",
    "contact": "Contacto",
    "contactInformation": "Información de Contacto",
    "dateOfBirth": "Fecha de Nacimiento",
    "department": "Departamento",
    "emails": "Correo(s) Electrónico(s) del Usuario",
    "emailsDescription": "Inserte 1 o más correos electrónicos, separados por punto y coma. Las invitaciones para registrarse como el rol de usuario elegido se enviarán a los usuarios por correo electrónico.",
    "filter": "Filtrar",
    "gender": "Género",
    "institution": "Institución",
    "institutionalAdmin": "Administrador de la Institución",
    "institutionAndDepartment": "Institución y Departamento",
    "inviteUsers": "Invitar Usuarios",
    "logOut": "Cerrar sesión    ",
    "nurse": "Enfermero/a",
    "password": "Contraseña",
    "patient": "Paciente",
    "resetPassword": "Restablecer la Contraseña",
    "resetRequestSentTo": "Correo electrónico de restablecimiento de contraseña enviado a",
    "searchUsers": "Buscar Usuario(s)",
    "sendResetPasswordEmailTo": "Enviar correo electrónico de restablecimiento de contraseña a",
    "sort": "Clasificar",
    "subscription": "Suscripción",
    "thisFieldIsRequired": "Este campo es obligatorio",
    "user": "Usuario",
    "userDetailsUpdated": "Datos de usuario actualizados",
    "userInformation": "Información del Usuario",
    "userRole": "Rol del Usuario"
  }
}